import { render, staticRenderFns } from "./bottomDialog.vue?vue&type=template&id=5baf1a62&"
import script from "./bottomDialog.vue?vue&type=script&lang=js&"
export * from "./bottomDialog.vue?vue&type=script&lang=js&"
import style0 from "./bottomDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports